/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsDefendifySetting } from './JumboStructsDefendifySetting';
import {
    JumboStructsDefendifySettingFromJSON,
    JumboStructsDefendifySettingFromJSONTyped,
    JumboStructsDefendifySettingToJSON,
} from './JumboStructsDefendifySetting';

/**
 * 
 * @export
 * @interface JumboStructsDefendifyProfile
 */
export interface JumboStructsDefendifyProfile {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifyProfile
     */
    profileDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifyProfile
     */
    profileID?: string;
    /**
     * 
     * @type {Array<JumboStructsDefendifySetting>}
     * @memberof JumboStructsDefendifyProfile
     */
    settings?: Array<JumboStructsDefendifySetting>;
}

/**
 * Check if a given object implements the JumboStructsDefendifyProfile interface.
 */
export function instanceOfJumboStructsDefendifyProfile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsDefendifyProfileFromJSON(json: any): JumboStructsDefendifyProfile {
    return JumboStructsDefendifyProfileFromJSONTyped(json, false);
}

export function JumboStructsDefendifyProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsDefendifyProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profileDisplayName': !exists(json, 'profileDisplayName') ? undefined : json['profileDisplayName'],
        'profileID': !exists(json, 'profileID') ? undefined : json['profileID'],
        'settings': !exists(json, 'settings') ? undefined : ((json['settings'] as Array<any>).map(JumboStructsDefendifySettingFromJSON)),
    };
}

export function JumboStructsDefendifyProfileToJSON(value?: JumboStructsDefendifyProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profileDisplayName': value.profileDisplayName,
        'profileID': value.profileID,
        'settings': value.settings === undefined ? undefined : ((value.settings as Array<any>).map(JumboStructsDefendifySettingToJSON)),
    };
}

